import { render, staticRenderFns } from "./RuleGetView.vue?vue&type=template&id=4229261e"
import script from "./RuleGetView.vue?vue&type=script&lang=js"
export * from "./RuleGetView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports